import { FormikProps } from "formik";
import React from "react";
import { ErrorsSummedUp } from ".";
import { ErrorsSummedUpProps } from "./interfaces";

interface Props extends ErrorsSummedUpProps {
  formProps: FormikProps<any>;
}

export const ErrorsSummedUpRender = ({
  formProps,
  errors,
  isVisible,
}: Props): React.ReactElement | null => {
  if (formProps.submitCount > 0 && !formProps.isValid) {
    return <ErrorsSummedUp errors={errors} isVisible={isVisible} />;
  }
  return null;
};
